import { Loader } from "lucide-react";
import {
  SessionCard,
  SessionCardProps,
} from "@/components/session/session-card.tsx";

interface SessionLineItem extends SessionCardProps {
  heading: string;
}

export function SessionTimelineItem({ heading, ...props }: SessionLineItem) {
  return (
    <div className="inline-flex w-full flex-col items-start justify-start gap-2.5 [&:not(:first-child)]:mt-4">
      <div className="inline-flex items-center justify-start gap-2.5 self-stretch">
        <div className="flex items-center justify-start gap-2.5">
          <div className="flex items-center justify-start gap-2.5 rounded bg-orange-100">
            <div className="flex items-center justify-start gap-2.5 p-1">
              <Loader size={12} />
            </div>
          </div>
          <div className="text-xs font-normal text-stone-500">{heading}</div>
        </div>
      </div>
      <div className="inline-flex items-start justify-start gap-2.5 self-stretch">
        <div className="flex w-4 items-start justify-start gap-2.5 self-stretch px-2">
          <div className="w-20 origin-top-left rotate-0 self-stretch border border-zinc-300"></div>
        </div>
        <SessionCard {...props} />
      </div>
    </div>
  );
}
